import logo from './assets/logo.png';

if (window.CONFIG.project === '8450034') {
  document.body.classList.add(`project-${window.CONFIG.project}`);
  
  Object.assign(window.CONFIG, {
    documentTitle: '程程白条',
    copyrightList: ['程程白条'],
    
    bizCode: 'TONGCHENG',
    sourceType: 'TONGCHENGBT_JD',
    
    clstagPrefix: 'jr|keycount|partnerPowerBaitiaoChengchengbaitiao|',
    psaPrefix: 'partnerPowerBaitiaoChengchengbaitiao_',
    
    floor: {
      channelName: 'TONGCHENG'
    },
    
    error: '系统开小差，请稍后再试',
    
    errorInfo: {
      // 未开通京东白条
      'EXT_ACT_ERROR_00001': '开通程程白条是白条用户的专属特权，快去激活白条后再来申请吧~',
      // 已申请成功
      'EXT_ACT_ERROR_00011': '您已激活程程白条，请勿重复申请',
      // 未在名单中
      'EXT_ACT_ERROR_00024': '很抱歉，暂无法为您提供此服务，您可以多打白条，按时还款，有助于您获得此白条专属特权。',
      // 白条账户状态异常
      'EXT_ACT_ERROR_00026': '开通程程白条是白条用户的专属特权，您的白条账户异常，展示无法为您提供此服务。'
    },
    
    // 宣导页
    index: {
      agreementKey: 'jd_tc_guide_ag_nos' // 协议key
    },
    
    // 关联页面
    auth: {
      agreementKey: '', // 协议key
      bizId: 'IVEP-TCBT-ACTIVE',// 人脸
      partner: {
        regAuthInfo: (phone) => `您的手机号<span class="highlight">${phone}</span>尚未注册同程旅游账号，将使用该手机号一键注册账号，同时授权在该账号下开通程程白条。您的程程白条消费将同时计入京东白条月账单。`,
        partnerInfoList: [
          {
            channelName: '',
            logo,
            name: '同程旅游',
            authInfo: (phone) => `授权的同程旅游账户<span class="highlight">${phone}</span>开通程程白条。您的程程白条消费将同时计入京东白条月账单。`
          }
        ]
      }
    },
    
    // 额度页
    home: {
      allQuotaTitle: '程程白条总额度',
      allQuotaInfo: '程程白条与京东白条共享同一额度。在同程旅游使用程程白条完成支付后，京东白条可用额度会同步减少。同样，在京东使用京东白条完成支付后，程程白条的可用额度也会同步减少。',
      notice: '使用说明：您可前往同程旅游app使用程程白条购买火车票、机票、进行酒店预订，您的消费将同时进入白条月账单'
    },
    
    // 成功页
    statusSuccess: {
      subTitle: '恭喜您成功开通程程白条，程程白条总额度',
      desc: '程程白条和京东白条共享同一额度,您可前往同程旅游app使用程程白条购买火车票、机票、进行酒店预订。'
    },
    
    // 失败页
    statusFailed: {
      subTitle: '抱歉，您暂时未通过系统综合评估，无法开通使用程程白条。',
      desc: '开通提示：多打白条按时还款，有助于提升信用！'
    }
  });
  
  window.CONFIG._autoRepay = true;
}


